import {
  chatboxActionTypes,
  toggleChatboxAction,
} from "@/fe-core/meta/types/chatbox";

export const toggleChatbox = (): toggleChatboxAction => ({
  type: chatboxActionTypes.TOGGLE_CHATBOX,
});
